import { reduxActions, requestStatus } from '../constants';
import { http, ResourceMap } from '../utils';

export default class ResourceActions {

    static resourceFetch(type = '', payload, config = {}) {
        let resource = ResourceMap.getResource(type);
        if (!resource) {
            return console.error('No resource of type ' + type + ' found');
        }

        resource = Object.assign({}, resource, config);
        let networkOptions = Object.assign({
            headers: resource.headers,
            responseType: resource.responseType
        }, resource.networkOptions, config.networkOptions);

        let url = resource.url;
        if (typeof resource.url === 'function') {
            url = resource.url(payload, config);
        }

        return dispatch => {
            let req = {
                method: resource.method,
                url: url,
                payload: payload,
                options: networkOptions
            }

            dispatch(ResourceActions.fetchStart(type, req));
            http._ajx(resource.method, url, payload, networkOptions)
            .success((res, status) => {
                dispatch(ResourceActions.fetchSuccess(type, res, status, req));
                dispatch(ResourceActions.resetFetchState());
                resource.onSuccess(res, status, dispatch);
            })
            .error((res, status) => {
                dispatch(ResourceActions.fetchFailed(type, res, status));
                dispatch(ResourceActions.resetFetchState());
                resource.onError(res, status, dispatch);
            })
        }
    }

    static setSearchParams(fetchType, searchParams) {
        return {
            type: reduxActions.RESOURCE_SET_SEARCH_PARAMS,
            fetchType: fetchType,
            searchParams: searchParams
        }
    }

    static fetchStart(type, request = {}) {
        return {
            type: reduxActions.RESOURCE_FETCH,
            progress: requestStatus.BUSY,
            message: '',
            fetchType: type,
            request: request
        }
    }

    static resetFetchState() {
        return {
            type: reduxActions.RESOURCE_FETCH,
            progress: requestStatus.INACTIVE,
            message: '',
            fetchType: '',
            request: {}
        }
    }

    static fetchSuccess(type, payload = {}, status, request = {}) {
        return {
            type: reduxActions.RESOURCE_FETCH_SUCCESS,
            progress: requestStatus.COMPLETE,
            message: 'Resources Successfully Returned',
            fetchType: type,
            payload: payload,
            status: status,
            request: request
        }
    }

    static fetchFailed(type, err, message) {
        return {
            type: reduxActions.RESOURCE_FETCH_FAIL,
            progress: requestStatus.ERROR,
            error: err,
            fetchType: type,
            message: message || ''
        }
    }

    static resourceFetchSuccess(type = '') {
        return dispatch => {
            dispatch(ResourceActions.fetchSuccess(type))
            dispatch(ResourceActions.resetFetchState())
        }
    }

    static resourceFetchFailed(message, type = '') {
        return dispatch => {
            dispatch(ResourceActions.fetchFailed(message, type))
            dispatch(ResourceActions.resetFetchState())
        }
    }

    static resetResource(fetchType) {
        return {
            type: reduxActions.RESOURCE_RESET,
            fetchType: fetchType
        }
    }
}



// WEBPACK FOOTER //
// ./web-app/actions/resource-actions.js